import releaseOfPersonalInformationAgreement from "./releaseOfPersonalInformationAgreement";
import studentData from "./studentData";

const enrollmentService = [
    {
        matcher: 'enrollment/agreement',
        reply: config => {
            return [200, releaseOfPersonalInformationAgreement];
        }
    },
    {
        matcher: 'enrollment/student',
        reply: config => {
            return [200, studentData];
        }
    }
]

export default enrollmentService;